import React, { Component } from "react";
import PropTypes from "prop-types";
import { Image, CloudinaryContext, Transformation } from "cloudinary-react";
import { url } from "../../CloudinaryService";

class Photo extends Component {
    render() {
        const options = { ...this.context, ...this.props };
        const urlPath = url(options.publicId, options);

        return (
            <div className="form-group">
                <a href={urlPath} target="_blank" rel="noopener noreferrer">
                    <Image
                        cloudName="motortrak"
                        publicId={this.props.publicId}
                        className="thumbnail inline"
                        width="300"
                    >
                    <Transformation quality="auto" fetchFormat="auto" />
                    </Image>
                </a>
            </div>
        );
    }

    static contextType = CloudinaryContext.contextType;
}

Photo.propTypes = {
    context: PropTypes.object,
    publicId: PropTypes.string
};

export default Photo;